import { useConstants } from './UseConstants';

export function useMainLayout() {
    const { language } = useConstants();

    return {
        areaClassName: 'main-layout-content main-layout-with-sidebar',
        areaSx: {
            float: language === 'en' ? 'right' : undefined,
        },
    };
}
